import { type NodeSpec } from "prosemirror-model";

// :: NodeSpec The top level document node.
export const doc: NodeSpec = {
	// a prosemirror document may either hold
	// 1 - a document placeholder node
	// 2 - one or more nodes that are compute_cell or text_cell types
	content: "(compute_cell|block)+",
	// Allow suggestion marks as block-level (node) marks for tracked changes.
	// This enables transformToSuggestionTransaction to wrap entire blocks
	// with deletion/insertion marks for external file changes.
	marks: "insertion modification deletion",
};
